import React from 'react';
import PropTypes from 'prop-types';
import styles from '../financeFlash/index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const FinanceHotList = ({ content = {} }) => {
    const { list = [], moreUrl = 'https://original.ifeng.com/finance/hotrank' } = content;

    if (!list.length) return null;

    return (
        <section className={styles.card} aria-labelledby="finance-hot-title" data-nosnippet>
            <div className={styles.head}>
                <h2 id="finance-hot-title" className={styles.title}>
                    财经热榜
                </h2>
            </div>
            <ul className={styles.list}>
                {list.map((item, index) => (
                    <li key={item.id || index} className={styles.item}>
                        <a href={item.url} className={styles.link} target="_blank" rel="noopener noreferrer">
                            <div className={styles.itemMain}>
                                <div className={styles.itemTitle}>{item.title}</div>
                                {item.time ? <time className={styles.time}>{item.time}</time> : null}
                            </div>
                        </a>
                    </li>
                ))}
            </ul>
            <a href={moreUrl} className={styles.moreBtn} target="_blank" rel="noopener noreferrer">
                查看更多
            </a>
        </section>
    );
};

FinanceHotList.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(FinanceHotList);
